var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4587 32.6667V16.0271L17.1503 21.3354L14.292 18.375L24.5003 8.16666L34.7087 18.375L31.8503 21.3354L26.542 16.0271V32.6667H22.4587ZM12.2503 40.8333C11.1274 40.8333 10.1665 40.4338 9.36749 39.6349C8.56852 38.8359 8.16835 37.8743 8.16699 36.75V30.625H12.2503V36.75H36.7503V30.625H40.8337V36.75C40.8337 37.8729 40.4342 38.8345 39.6352 39.6349C38.8362 40.4352 37.8746 40.8347 36.7503 40.8333H12.2503Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.8be126d2ce13eb66e7aa55fad0be3035.svg";
export { ForwardRef as ReactComponent };